
    import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
    import VueDatetimeJs from 'vue-datetime-js'
    import moment from 'moment';
    moment.updateLocale('ar-sa', {
        postformat: function(string:any) {
            return string
                .replace(/\d/g, function(match: any) {
                    return match;
                })
                .replace(/,/g, '،')
        }
    })

    @Component({
        components: {datePicker: VueDatetimeJs},
        directives: {},

    })
    export default class FilterComponent extends Vue {
      
        public showFilters: boolean = false;
        public filter: any = {};
        public isOpen: boolean = false;
        public expanded: boolean[] = [false];
        public searchPlaceHolder: string = "بحث";
        public searchInputType: string = "text";

        public filterForm: any = {};
        public timer: any = {};

        @PropSync('filterFields', { default: undefined })
        public syncedFilterFields!: any;
        @Prop()
        closeIt: boolean = false;
        isInstitute: boolean = false;


        public async mounted() {
            
            this.filterForm['search'] = '';
            this.syncedFilterFields.map((e: any) => {
                this.filterForm[e.name] = e.defaultValue;
            });
            console.log( this.syncedFilterFields, 'filters')
            this.filterForm = { ...this.filterForm };
            
        }

        @Watch('closeIt')
        public onIsOpenedChanged(value: string, oldValue: string) {
            this.reset();
        }

        public reset() {
            this.showFilters = false;
            this.filter = {};
            this.isOpen = false;
            this.expanded = [this.isOpen];
            this.filterForm = {};
            this.timer = {};

            this.filterForm['search'] = '';
            this.syncedFilterFields.map((e: any) => {
                this.filterForm[e.name] = e.defaultValue;
            });
            this.filterForm = { ...this.filterForm };

            this.$emit('onchange', { key: '', value: '', fullForm: this.filterForm });


        }

        public toggleFilters() {
            this.isOpen = !this.isOpen;
            this.expanded = [this.isOpen];
        }

        public filterChanged(event: any) {


        }

        onchange(event: any) {
            if (event.target.id == 'byid' && event.target.value == 2) {
                this.searchPlaceHolder = "YYYY/MM/DD";
                this.searchInputType = "date";
            }
            else {
                this.searchPlaceHolder = "البحث";
                this.searchInputType = "text";
            }

            this.filterForm[event.target.id] = event.target.value;
            this.filterForm = { ...this.filterForm };
            // if(this.filterForm.search.length > 0 && )
            //     this.$emit('onchange', { key: event.target.id, value: event.target.value, fullForm: this.filterForm });
            this.$emit('onchange', { key: event.target.id, value: event.target.value, fullForm: this.filterForm });
        }

        onChangeDelay(event: any) {
            // console.log('delay')
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.onchange(event);
            }, 200);


        }
    }
